module.exports = __webpack_public_path__ + "onboarding-feed-builtin.a074bb39def311a023a938893b5940ef.hashedasset.svg";